<script>
  import { gql } from "@apollo/client/core";
  import { query } from "svelte-apollo";
  import { _ as t } from "svelte-i18n";

  import { info } from "notifications/notify.js";

  import { client } from "apollo.js";

  import { UPDATE_CLIENT_PASSWORD_MUTATION } from "queries.js";
  import { Button, Title } from "t2c-components";
  import Input from "components/Input.svelte";

  let currentPassword = "";
  let newPassword = "";
  let newPasswordConfirmation = "";

  let errors = {};
  let message;

  const ME_CLIENT_QUERY = gql`
    query {
      meClient {
        id
        name
      }
      organizationConfig {
        id
        name
      }
    }
  `;

  const meClientDetail = query(client, {
    query: ME_CLIENT_QUERY,
  });

  const submit = async () => {
    try {
      const result = await client.mutate({
        mutation: UPDATE_CLIENT_PASSWORD_MUTATION,
        variables: {
          password: currentPassword,
          newPassword: newPassword,
          newPasswordConfirmation: newPasswordConfirmation,
        },
      });
      console.log(result);
      errors = {};
      currentPassword = "";
      newPassword = "";
      newPasswordConfirmation = "";
      info("Password updated succesfully");
      message = "Password updated succesfully";
    } catch ({ graphQLErrors, networkError }) {
      let messages = {};
      graphQLErrors.map(({ key, message }) => (messages[key] = message));
      errors = messages;
      message = null;
    }
  };
</script>

<div class="container">
  <section class="wrapper">
    {#await $meClientDetail then _result}
      <div class="box">
        <Title title={$t("settings")} />
      </div>
      <div class="box">
        <div class="form">
          <h3>{$t("userSettings.changePassword")}</h3>
          <p>{$t("userSettings.minLengthPassword")}</p>
          <Input
            type="password"
            label={$t("userSettings.currentPassword")}
            bind:value={currentPassword}
          />
          {#if errors["password"]}
            {#each errors["password"] as message}
              <p>{message}</p>
            {/each}
          {/if}

          <Input
            type="password"
            label={$t("userSettings.newPassword")}
            bind:value={newPassword}
          />
          {#if errors["new_password"]}
            {#each errors["new_password"] as message}
              <p>{message}</p>
            {/each}
          {/if}

          <Input
            type="password"
            label={$t("userSettings.newPasswordConfirm")}
            bind:value={newPasswordConfirmation}
          />
          {#if errors["new_password_confirmation"]}
            {#each errors["new_password_confirmation"] as message}
              <p>{message}</p>
            {/each}
          {/if}

          {#if message}
            <div class="message">
              <p>{message}</p>
            </div>
          {/if}
          <div class="form-action">
            <Button
              style="primary"
              text={$t("userSettings.change")}
              on:click={submit}
            />
          </div>
        </div>
      </div>
    {/await}
  </section>
</div>

<style>
  .container {
    width: 100%;
  }

  .wrapper {
    margin: 0 auto;
    max-width: 1020px;
  }

  .box {
    padding-top: 24px;
    border-top: 1px solid var(--blue-color);
  }

  .box:first-child {
    border-top: 0;
  }

  .box h3 {
    margin: 0;
    padding: 18px 0 12px;
    font-size: 20px;
    font-weight: 100;
    color: var(--blue-color);
  }

  .box p {
    margin: 0 0 48px;
    font-size: 14px;
  }

  .form {
    margin: 0 auto 64px;
  }

  .form-action {
    margin-top: 48px;
  }

  .message p {
    color: var(--marine-color);
  }

  @media only screen and (min-width: 600px) {
    .form {
      width: 480px;
      max-width: 480px;
    }
  }
</style>
